import { render, staticRenderFns } from "./DebugComp.vue?vue&type=template&id=a9f7a090"
import script from "./DebugComp.vue?vue&type=script&lang=ts"
export * from "./DebugComp.vue?vue&type=script&lang=ts"
import style0 from "./DebugComp.vue?vue&type=style&index=0&id=a9f7a090&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports